<template>
  <v-container class="fill-heigt" fluid>
    <v-row class="d-flex flex-row justify-space-between align-center my-10">
      <div>
        <v-btn icon color="primary" @click="$router.back()">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </div>
    </v-row>

    <v-row>
      <v-expansion-panels v-model="panel">
        <template v-for="interview in interviews.completed">
        
          <expansion-panel
            :interviewId="$route.params.id"
            :interviews="interview"
            :isCompleted="true"
            :vacancyId="interview[0].vacancyId"
            :key="interview.timestemp"
          />
        </template>
      </v-expansion-panels>
    </v-row>

    <add-recruter-dialog />
    <add-observer-dialog />
    <re-schedule-interview />
    <finish-interview />
    <!-- <reject-candidate-dialog /> -->
    <success-dialog />
    <send-proposal-dialog />
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import { v4 as uuid } from "uuid";
import { GET_INTERVIEW_BY_ID_QUERY } from "../graphql/Query.gql";
import { UPDATE_INTERVIEW_SCHEDULE_SUBSCRIPTION } from "../graphql/Subscraption.gql";
import { groupBy } from "@/utils";
import ExpansionPanel from "../components/panel/approved/ExpansionPanel.vue";
import AddRecruterDialog from "../components/AddRecruterDialog.vue";
import AddObserverDialog from "../components/AddObserverDialog.vue";
import ReScheduleInterview from "../components/ReScheduleInterview.vue";
import FinishInterview from "../components/FinishInterview.vue";
// import RejectCandidateDialog from "../components/RejectCandidateDialog.vue";
import SuccessDialog from "../components/SuccessDialog.vue";
import SendProposalDialog from "../components/SendProposalDialog.vue";

export default {
  name: "ScheduledInterview",

  components: {
    ExpansionPanel,
    AddRecruterDialog,
    AddObserverDialog,
    ReScheduleInterview,
    FinishInterview,
    // RejectCandidateDialog,
    SuccessDialog,
    SendProposalDialog,
  },

  data: () => ({
    interview: {},
    text: "",
    alert: true,
    panel: null,
  }),

  apollo: {
    interview: {
      query: GET_INTERVIEW_BY_ID_QUERY,
      variables() {
        return { id: this.$route.params.id };
      },
      fetchPolicy: "cache-and-network",
    },
    $subscribe: {
      updateInterviewSchedule: {
        query: UPDATE_INTERVIEW_SCHEDULE_SUBSCRIPTION,
        result({ data }) {
          this.interview = data.updateInterviewSchedule;
        },
      },
    },
  },

  watch: {
    interview(val) {
      if (this.$route.query.candidateIdOrEmail) {
        const candidateIdOrEmail = this.$route.query.candidateIdOrEmail;
        let candidates = val.candidates;
        candidates = candidates.filter(
          (filterCandidate) =>
            filterCandidate.status === "approved" ||
            filterCandidate.status === "rejected" ||
            filterCandidate.status === "finished" ||
            filterCandidate.status === "canceled"
        );
        const findedInterviewIndex = candidates.findIndex(
          (findCompleted) =>
            (findCompleted.interviewee &&
              findCompleted.interviewee.id === candidateIdOrEmail) ||
            (!findCompleted.interviewee &&
              findCompleted.email === candidateIdOrEmail)
        );

        this.panel = findedInterviewIndex;
      }
    },
  },

  computed: {
    ...mapGetters({
      getBlockedCandidates: "candidate/getBlockedCandidates",
    }),
    interviews() {
      const ZERO_NUMBER = 0;
      const blockeds = this.getBlockedCandidates;
      const candidates = this.interview.candidates;
      let list = candidates
        ? candidates.map((findCandidate) => {
            const findIndex = blockeds.findIndex(
              (blockedId) =>
                findCandidate.interviewee &&
                blockedId == findCandidate.interviewee.id
            );
            // const stage = findCandidate.stages.find(
            //   (findStage) => findStage.name === findCandidate.currentStage
            // );
            return {
              ...findCandidate,
              address: this.interview.address,
              subject: this.interview.subject,
              telephone: this.interview.telephone,
              message: this.interview.message,
              vacancyId: this.interview.vacancy.id,
              // timestemp: `${stage.date} ${stage.time} ${stage.groupBy}`,
              timestemp: uuid(),
              // uuid: uuid(),
              blocked: findIndex >= ZERO_NUMBER,
            };
          })
        : [];

      const outstanding = list.filter(
        (filterCandidate) =>
          filterCandidate.status !== "approved" &&
          filterCandidate.status !== "rejected" &&
          filterCandidate.status !== "finished" &&
          filterCandidate.status !== "canceled"
      );

      list = list.filter(
        (filterCandidate) => filterCandidate.status === "approved"
      );

      console.log({ list });

      const completed = groupBy(list, "timestemp", (record, dateKey) => {
        return [record[dateKey]];
      });

      let resultItems = { outstanding, completed };

      // if (this.textSearch) {
      //   const text = this.replaceSpecialChars(this.textSearch)
      //   list = list.filter(c =>
      //     this.replaceSpecialChars(resultItems[`${c.date} ${c.time}`][0].candidate.fullName).includes(text)
      //   )
      // }

      resultItems.completed = groupBy(list, "timestemp", (record, dateKey) => {
        return [record[dateKey]];
      });

      return resultItems;
    },
  },

  methods: {
    go() {
      this.$router.push({
        name: "scheduled.interviews",
        params: {
          id: this.$route.params.id,
        },
      });
    },
  },

  mounted() {
    // if (this.$route.query.candidateIdOrEmail) {
    //   const candidateIdOrEmail = this.$route.query.candidateIdOrEmail;
    //   const findedInterviewIndex = this.interviews.completed.findIndex(
    //     (findCompleted) =>
    //       (findCompleted.interviewee &&
    //         findCompleted.interviewee.id === candidateIdOrEmail) ||
    //       (!findCompleted.interviewee &&
    //         findCompleted.email === candidateIdOrEmail)
    //   );
    //   this.panel = findedInterviewIndex;
    // }
  },
};
</script>
